const env = process.env;
export const getConfig = (name) => global?.__env__?.[name] ?? env[name];

export default getConfig;
